type Names = { firstName: string; lastName: string };

export function getFullName({ firstName, lastName }: Names) {
  return `${firstName} ${lastName}`;
}
